import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsCardHolderSchema = withDefaults({
  type: 'pcs-card-holder',
  fields: [
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'providerData',
    },
    {
      kind: 'attribute',
      name: 'legalName',
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: 'pcsCardHolders',
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasApplication',
      type: 'tas-application',
      options: {
        async: false,
        inverse: 'pcsCardHolders',
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsCompany',
      type: 'pcs-company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsCards',
      type: 'pcs-card',
      options: {
        async: false,
        inverse: 'pcsCardHolder',
      },
    },
  ],
});

export default PcsCardHolderSchema;
